import { render } from "./BannerSwiper.vue?vue&type=template&id=173cbf76"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
script.render = render

export default script